/**
 * @generated SignedSource<<3a18fa91270bb508f276c79b75f11927>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UnfollowTopicInput = {
  topicSlug: string;
};
export type DiscoverPageUnfollowMutation$variables = {
  input: UnfollowTopicInput;
};
export type DiscoverPageUnfollowMutation$data = {
  readonly unfollowTopic: {
    readonly topic: {
      readonly followerCount: number;
      readonly id: string;
      readonly isFollowedByViewer: boolean | null | undefined;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type DiscoverPageUnfollowMutation = {
  response: DiscoverPageUnfollowMutation$data;
  variables: DiscoverPageUnfollowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnfollowTopicPayload",
    "kind": "LinkedField",
    "name": "unfollowTopic",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFollowedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followerCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscoverPageUnfollowMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscoverPageUnfollowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "15861aa4840927dd5da32f32ce8b0fd9",
    "id": null,
    "metadata": {},
    "name": "DiscoverPageUnfollowMutation",
    "operationKind": "mutation",
    "text": "mutation DiscoverPageUnfollowMutation(\n  $input: UnfollowTopicInput!\n) {\n  unfollowTopic(input: $input) {\n    topic {\n      id\n      isFollowedByViewer\n      followerCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "710046e5713444f9c89edfed606b737c";

export default node;
